/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { COMMITTEE_REPORT } from "../graphql/CommitteeReport.query";
import { VApplication } from "../../../application";
import moment from "moment";

const is = require("is_js");

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCommitteeReportMethods extends IPluginMethodMap {
    getCommitteeReport(args: any): Promise<any>;
}

export class GetCommitteeReportService implements IAgentPlugin {
    readonly methods: IGetCommitteeReportMethods;

    constructor() {
        this.methods = {
            getCommitteeReport: this.getCommitteeReport.bind(this),
        };
    }

    async getCommitteeReport(args: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        console.log("filet apply====", args?.payload);
        let variables: any = {
            presentation: {
                eq: args?.payload?.presentation,
            }
        };
        if (args?.payload?.committee) {
            variables = {
                ...variables,
                InvitedBy___email: {
                    eq: args?.payload?.committee
                }
            }
        }
        console.log("filter in full payment user", variables);
        try {
            if (client) {
                const res = await client.query({
                    query: COMMITTEE_REPORT,
                    variables: {
                        filter: variables
                    },
                    fetchPolicy: "network-only",
                });
                return res
            }
        } catch (err: any) {
            let _display_message =
                err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.find((item: any) => item.extensions);
            if (_display_message?.extensions?.display_message) {
                throw Error(_display_message?.extensions?.display_message);
            }

            throw err;
        }
    }

}
